import { css } from "@linaria/core";
import React from "react";
import { useProjects } from "../../../api/useProjects";
import t from "../../../i18n";
import { browserTimeZones, defaultTimeZone as IntlDefaultTimeZone } from "../../../lib/time/intl";
import Select from "@ui/Select";
import { useTimeZoneInput } from "../../Projects/useTimeZoneInput";

export default function TimeZoneSelector({
  defaultValue,
  onChange,
}: {
  defaultValue: string | undefined;
  onChange: (timeZone: string) => void;
}) {
  const projects = useProjects();
  const {
    onTimeZoneChanged,
    timeZoneValue,
    timeZonePlaceholder,
    isTimeZoneValueDirty,
    onRollbackTimeZone,
  } = useTimeZoneInput({ initialTimeZone: defaultValue });

  const timeZonesOptions = React.useMemo(() => {
    const timeZones = [...new Set([...browserTimeZones, IntlDefaultTimeZone])];
    return timeZones.map(tz => ({ value: tz, label: tz }));
  }, []);

  const handleTimeZoneChanged = React.useCallback(
    (e: React.ChangeEvent<HTMLSelectElement>) => {
      onChange(e.target.value);
      onTimeZoneChanged(e);
    },
    [onTimeZoneChanged, onChange],
  );

  return (
    <Select
      className={TimeZoneSelectorField}
      required
      filtered
      onChange={handleTimeZoneChanged}
      value={timeZoneValue}
      options={timeZonesOptions}
      prompt={timeZonePlaceholder}
      revertable={projects.length > 0 && isTimeZoneValueDirty}
      revert={onRollbackTimeZone}
      clearable={false}
      label={t("dateSource.import.timezone.selectLabel")}
    />
  );
}

const TimeZoneSelectorField = css`
  width: 100%;
`;
